import { Colors } from "../../../consts/Colors";
import FONTS from "../../../consts/Fonts";

export default class ButtonMenu extends Phaser.GameObjects.Container {
    constructor(scene, x, y, {text, icon, color, hoverColor, borderColor}) {
        super(scene, x, y, []);

        this.scene = scene;
        scene.add.existing(this);

        this.soundManager = scene.soundManager

        this.isLocked = false

        this.color = color
        this.hoverColor = hoverColor
        this.borderColor = borderColor

        this.addBody({text, icon, color, borderColor})        
        // Ajout intéractions
        this.setInteractive({useHandCursor: true});

        this.on('pointerover', () => {
            this.pointerOver()
        })

        this.on('pointerout', () => {
            this.pointerOut()
        })
    }

    setClickFunction( clickFunction ){
        this.on('pointerup', () => {
            this.soundManager.playOnce('Button3')
            this.scene.tweens.add({
                targets: this,
                scale: 0.9,
                duration: 100,
                yoyo: true,
                ease: 'Cubic.easeInOut',
                onComplete: () => {
                    clickFunction(this);
                }
            })
        }, this.scene);
    }

    // -- A completer dans les class enfants

    addBody({text, icon, color, borderColor}){
        this.background = this.scene.add.rexRoundRectangle(0, 0, 264, 264, 24, color);
        this.background.setStrokeStyle(4, borderColor);
        this.add(this.background);

        let textElmt = this.scene.add.text(-this.background.width / 2 + 32, -this.background.height / 2 + 32, text, {
            fontFamily: FONTS.InterSemiBold,
            fontSize: '18px',
            color: Colors.Text.White,
        });
        textElmt.setOrigin(0);
        this.add(textElmt);

        let iconElmt = this.scene.add.image(-this.background.width / 2 + 32, this.background.height / 2 - 32, icon).setOrigin(0,1);
        this.add(iconElmt);

        let arrow = this.scene.add.image(this.background.width / 2 - 32, this.background.height / 2 - 32, 'icon_fleche').setOrigin(1,1);
        this.add(arrow);

        this.setSize(this.background.width, this.background.height);
    }

    pointerOver(){
        this.scene.tweenShapeColor(this.background, this.hoverColor, 200);
    }

    pointerOut(){
        this.scene.tweenShapeColor(this.background, this.color, 200);
    }

    setLocked(){
        // Ajout de l'état bloqué
        this.isLocked = true
    }

    setUnlocked(){
        // Ajout de l'état débloqué
        this.isLocked = false
    }
}